const getters = {
    loginInfo: (state) => state.loginInfo.info, 
    okForm:(state) => state.workPlace.okForm, 
    workPlace:(state) => state.workPlace,
    formwork: (state) => state.formwork.formwork,
    inputOptions: state => state.formwork.inputOptions,
    selectOptions: state => state.formwork.selectOptions,
    sliderOptions: state => state.formwork.sliderOptions,
    radioOptions: state => state.formwork.radioOptions,
    timeOptions: state => state.formwork.timeOptions,
    checkBoxOptions: state => state.formwork.checkBoxOptions,
    formwork: state => state.formwork.formwork,
    switchOptions: state => state.formwork.switchOptions,
    inputNumberOptions: state => state.formwork.inputNumberOptions
  }
  export default getters
  